import React,{ Component, useState, useEffect } from 'react';
import {Link} from "react-router-dom"
import Header from "./header"
import axios from 'axios'
import Login from "./login"
import { useNavigate } from "react-router-dom";

import { IconButton } from "@mui/material";
import Logout from "@mui/icons-material/Logout";

const defaultApps = [
  {
    id: 'music',
    name: 'Music',
    icon: '/icons/icon-192.png'
  },
  {
    id: 'todo',
    name: 'Todo',
    icon: '/icons/icon-192.png'
  },
  {
    id: 'vault',
    name: 'Vault',
    icon: '/icons/icon-192.png'
  }
];

const LogoutIcon = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login", {replace:true, hidePath:true})
  };

  return (
    <IconButton onClick={handleLogout} title="Logout">
      <Logout />
    </IconButton>
  );
};

const Walmates = () => {
  const [apps, setApps] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const isOffline = !navigator.onLine;
    const token = localStorage.getItem('walmates-token');
    const user_id = localStorage.getItem('walmates-user_id');

    if (isOffline) {
      setApps(defaultApps);
      return;
    }

    axios.get(`/api/apps?`, {
      params: { user_id },
      headers: { 'Authorization': `Bearer ${token}` }
    })
    .then(response => {
      console.log("Apps Data:", response.data)
      setApps(response.data);
    })
    .catch(error => {
      console.log("Error received:", error);
      localStorage.clear();
      navigate("/login", {replace:true, hidePath:true})
    });
  }, []);

  return (
    <div className="wall">
      <Header />
      <div className="apps_container">
        <ul>
          { apps.map(app => (
            <li key={app.id}>
              <App key={app.id} app={app} />
            </li>
          ))}
        </ul>
      </div>
      <div className="wallbody">
        <LogoutIcon/>
      </div>
    </div>
  );
};

const App = (props) => {
  return (
    <div className="app_cover">
      <Link to={`/${props.app.name.toLowerCase()}`}>
        <img className="app_logo" src={props.app.icon}/>
        <div className="app_title">{props.app.name}</div>
      </Link>
    </div>
  );
};

export default Walmates;

